import HeroShader from '../pages/HeroShader';
import buttonArrowRight from '../assets/icons/button-arrow-right.svg';
import blckshub from '../assets/hero/blckshub.avif';

const Hero = () => {
  return (
    <main>
      <section className="relative h-[800px] md:h-[1200px] lg:h-[1438px] overflow-hidden" style={{backgroundColor: '#030507'}}>
        {/* SEO-optimized H1 that's visually hidden but accessible to screen readers */}
        <h1 className="sr-only">blcks AI - KI Consulting & KI Automatisierung für Ihr Unternehmen</h1>
        {/* Gradient overlay for smooth transition to Banner */}
        {/*<div className="absolute bottom-0 left-0 w-full h-[300px] z-10" 
             style={{
               background: 'linear-gradient(to bottom, transparent 0%, #030507 100%)',
               pointerEvents: 'none'
             }}
        />*/}
        <div className="container relative h-full px-4 mx-auto md:mx-4 lg:mx-auto max-w-7xl flex items-center">
          <div className="relative z-30 w-full px-4 -mt-[350px] md:-mt-[400px] lg:-mt-[700px] text-center md:max-w-[500px] md:px-0 md:text-left">
            {/*<h1 className="font-calsans text-4xl md:text-[68px] font-bold leading-[1.1] bg-gradient-to-br from-white from-30% via-[#d5d8f6] via-80% to-[#fdf7fe] bg-clip-text text-transparent mx-auto md:mx-0">
              We Simplify &<br />Scale With AI.
            </h1>*/}
            <h1 className="font-calsans text-4xl md:text-[64px] font-bold leading-[1.1] bg-gradient-to-br from-white from-30% via-[#d5d8f6] via-80% to-[#fdf7fe] bg-clip-text text-transparent mx-auto md:mx-0">
              Ihr Partner für <br/> Next-Gen KI Transformation.
            </h1>
            <p className="font-geist mt-7 mb-4 text-sm sm:text-base font-light leading-[1.3] text-[#adb0b9] max-w-[300px] sm:max-w-lg tracking-normal mx-auto md:mx-0">
              Wir zeigen dir, wo KI echten Mehrwert liefert und setzen unsere Lösungen gezielt ein, um dein Business schneller, effizienter und profitabler zu machen.
            </p>
            {/*<p className="font-geist mt-7 text-[16px] font-light leading-[1.3] text-[#adb0b9] max-w-lg tracking-normal">
              Dein Unternehmen braucht keine weiteren Tools. Es braucht Klarheit, wo AI echtes Wachstum freisetzt und skalierbare Ergebnisse liefert.
            </p>*/}
            <a 
              href="https://audit.blcks.at"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-shadow duration-300 group inline-flex items-center relative justify-center rounded-full tracking-tight h-10 text-16 px-[18px] bg-white text-black font-medium mt-4 md:mt-8 w-fit shadow-[0px_6px_16px_rgba(255,255,255,.2)] hover:shadow-[0px_6px_56px_0px_rgba(255,255,255,.4),0px_4px_15px_0px_rgba(0,0,0,.2)] lg:mt-6 mx-auto md:mx-0"
            >
              <span 
                className="pointer-events-none absolute inset-0 z-0 rounded-[inherit] bg-gradient-to-r from-white to-gray-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                aria-hidden="true"
              />
              <span className="relative z-10">Analyse starten</span>
              <img 
                src={buttonArrowRight} 
                alt="" 
                className="relative z-10 ml-1.5 h-5 w-5 shrink-0" 
                width={16} 
                height={16} 
              />
            </a>
          </div>
          
          {/* HeroShader background */}
          <div className="absolute left-1/2 -translate-x-1/2 w-screen h-full mix-blend-lighten overflow-hidden">
            <div className="absolute inset-0 w-full h-full">
              <HeroShader />
            </div>
          </div>

          {/* Base image */}
          <div className="absolute bottom-[50px] left-4 w-[calc(150%+2rem)] h-auto max-w-[1200px] aspect-[1024/569] lg:bottom-[140px] lg:left-8 lg:w-[1024px]">
            <img
              src={blckshub}
              alt=""
              fetchpriority="high"
              width="1024"
              height="569"
              decoding="async"
              className="w-full h-full rounded-[10px]"
              style={{ color: 'transparent' }}
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default Hero;